import { HireApplicantFormModel } from '../../../agent/components/hire-applicant-form/HireApplicantForm';
import { GEO_FORM_MODEL_DEFAULT_VALUES } from '../../../geo/components/form-geo-field/constants';
import { JobApplicationType, JobTitle } from '../../../domain/types';
import {
  Applicant, HireApplicant, JobApplicationSales, JobApplication,
} from '../../../providers/api/dtos';
import { booleanStringToBool, boolToBooleanString } from '../../../utils/boolean-string/booleanString';

export const getInitialValuesFromApplicant = (jobApplication: JobApplicationSales, applicant: Applicant): HireApplicantFormModel => {
  const nameWords = applicant.name.trim().split(' ').filter((word) => word !== '');
  const name = nameWords[0];
  const surname = nameWords.slice(1).join(' ');

  return {
    workName: name,
    workSurname: surname,
    personalName: '',
    personalSurname: '',
    workEmail: '',
    personalEmail: applicant.email || '',
    pecEmail: '',
    workMobile: '',
    personalMobile: applicant.phoneNumber || '',
    fiscalCode: '',
    residenceAddress: GEO_FORM_MODEL_DEFAULT_VALUES,
    shippingAddress: GEO_FORM_MODEL_DEFAULT_VALUES,
    role: '',
    startDate: '',
    hasLicense: boolToBooleanString(jobApplication.hasLicense) || '',
    needsSupervisor: '',
    inTrial: false,
  };
};

export const applicantToHire = (jobApplication: JobApplication, hireApplicantFormModel?: HireApplicantFormModel): HireApplicant => (
  jobApplication.applicationType === 'GENERIC'
    ? {
      applicationType: JobApplicationType.GENERIC,
      jobApplicationId: jobApplication.id!,
    }
    : {
      applicationType: JobApplicationType.SALES,
      name: hireApplicantFormModel!.workName,
      surname: hireApplicantFormModel!.workSurname,
      email: hireApplicantFormModel!.personalEmail,
      phoneNumber: hireApplicantFormModel!.personalMobile,
      jobApplicationId: jobApplication.id!,
      jobTitle: hireApplicantFormModel!.role as JobTitle,
      startDate: hireApplicantFormModel!.startDate,
      hasLicense: booleanStringToBool(hireApplicantFormModel!.hasLicense) as boolean,
      needsSupervisor: booleanStringToBool(hireApplicantFormModel!.needsSupervisor) as boolean,
      inTrial: hireApplicantFormModel!.inTrial,
      personalName: hireApplicantFormModel!.personalName || undefined,
      personalSurname: hireApplicantFormModel!.personalSurname || undefined,
      workEmail: hireApplicantFormModel!.workEmail || undefined,
      pecEmail: hireApplicantFormModel!.pecEmail || undefined,
      workMobile: hireApplicantFormModel!.workMobile || undefined,
      fiscalCode: hireApplicantFormModel!.fiscalCode || undefined,
      residenceAddress: hireApplicantFormModel!.residenceAddress,
      shippingAddress: hireApplicantFormModel!.shippingAddress,
    });
